export const menuItems = [
  {
    name: "#products",
    label: "Products",
    isExternal: false
  },
  {
    name: "#pricing",
    label: "Pricing",
    isExternal: false
  },
  {
    name: "help",
    label: "How to",
    isExternal: false
  }
];
